<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->


<div class="row" *ngIf="!history">
  <div class="col pt-2">
    <div class="col wccard pt-1 pb-0 mb-1" *ngIf="userisadmin || (showteamtab && !isteammember)">
      <ul class="nav nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-subscription-usage-a-1" class="nav-link active" id="pills-plan-tab" data-bs-toggle="pill" href="#pills-plan" role="tab"
            aria-controls="pills-plan" aria-selected="true">Plan</a>
        </li>
        <li class="nav-item" role="presentation">
          <a data-testid="auto-app-subscription-usage-a-2" class="nav-link" id="pills-team-tab" data-bs-toggle="pill" href="#pills-team" role="tab"
            aria-controls="pills-team" aria-selected="false">Team</a>
        </li>
      </ul>
    </div>

    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-plan" role="tabpanel" aria-labelledby="pills-plan-tab">
        <div>
          <div class="wccard mb-1" *ngIf="!isteammember">
            <div class="d-flex justify-content-between">
              <div class="col font-weight-500 pt-3 pb-6">
                Plan Details
              </div>

              <span class="m-2" *ngIf="stripesubscriptionid">
                <button data-testid="auto-app-subscription-usage-button-1" class="btn-trms-white" (click)="cancelsubs('modal')">Cancel
                  Subscription</button>
              </span>
            </div>
            <div class="col d-flex justify-content-between pl-0">
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20">
                  {{subscriptiondetails?.paymentplanname}}
                </p>
                <p class="gray-text f-12">
                  Plan
                </p>
              </div>
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.plancost != 'free'">
                  <span class="f-18">
                    $ {{subscriptiondetails?.plancost}}/</span> <span
                    *ngIf="subscriptiondetails?.plantype =='custom' || subscriptiondetails?.plantype =='monthly'">Month</span>
                  <span *ngIf="subscriptiondetails?.plantype == 'yearly'">
                    Year
                  </span>
                </p>
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.plancost == 'free'">
                  Free
                </p>
                <p class="gray-text f-12">
                  Price
                </p>
              </div>
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20">
                  <span
                    *ngIf="(subscriptiondetails?.plantype == 'custom' || subscriptiondetails?.plantype =='monthly') && subscriptiondetails?.plancost != 'free'">
                    Monthly
                  </span>
                  <span *ngIf="subscriptiondetails?.plancost == 'free'">
                    NA
                  </span>
                  <span *ngIf="subscriptiondetails?.plantype == 'yearly'">
                    Annual
                  </span>
                </p>
                <p class="gray-text f-12">
                  Duration
                </p>
              </div>
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.plancost != 'free'">
                  {{subscriptiondetails?.paymentplanenddate | date:'longDate'}}
                </p>
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.plancost == 'free'">
                  NA
                </p>
                <p class="gray-text f-12">
                  Renewal Date
                </p>
              </div>
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.paymentplanstartdate">
                  {{subscriptiondetails?.paymentplanstartdate | date:'longDate'}}
                </p>
                <p class="font-weight-500 mb-1 mh-20" *ngIf="!subscriptiondetails?.paymentplanstartdate">
                  NA
                </p>
                <p class="gray-text f-12">
                  Start Date
                </p>
              </div>
              <div class="col">

              </div>
            </div>

            <div class="row px-3 mr-6">
              <!-- <div class="col-md-5 py-6" *ngIf="userisadmin">
                <p class="font-weight-500 mb-1">
                  Overall premium partner coins
                </p>
                <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcreditce" placement="top">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.overallpercentage}}">
                  </mat-progress-bar>
                </p>

                <ng-template #remainingcreditce>
                  <span class="f-10">
                    Remaining coins : {{subscriptiondetails?.overallcredits}}
                  </span>
                </ng-template>
                <div class="justify-content-between d-flex f-12">
                  <span class="font-weight-500">
                    0
                  </span>
                  <span class="font-weight-500">
                    {{subscriptiondetails?.contactenrichmentcredits}}<span
                      *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                      *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                  </span>
                </div>
              </div> -->

              <div class="col-md-5 py-6 mr-6" *ngIf="userisadmin">
                <p class="font-weight-500 mb-1">
                  Overall contact coins
                </p>
                <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcreditbce" placement="top"
                  *ngIf="!unlimitedbasiccontactcredits">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.overallbasicpercentage}}">
                  </mat-progress-bar>
                </p>

                <p class="gray-text f-12 mb-1" *ngIf="unlimitedbasiccontactcredits">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.overallbasicpercentage}}">
                  </mat-progress-bar>
                </p>

                <ng-template #remainingcreditbce>
                  <span class="f-10">
                    Remaining coins : {{subscriptiondetails?.overallbasiccredits}}
                  </span>
                </ng-template>
                <div class="justify-content-between d-flex f-12">
                  <span class="font-weight-500">
                    0
                  </span>
                  <span class="font-weight-500" *ngIf="!unlimitedbasiccontactcredits">
                    {{subscriptiondetails?.basiccontactenrichmentcredits}}<span
                      *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                      *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                  </span>
                  <span class="font-weight-500" *ngIf="unlimitedbasiccontactcredits">
                    Unlimited
                  </span>
                </div>
              </div>
            </div>

          </div>

          <div class="wccard mb-1" *ngIf="isteammember">
            <div class="col font-weight-500 pt-3 pb-3 d-flex justify-content-between">
              <span>
                Team Details
              </span>

              <span>
                <button data-testid="auto-app-subscription-usage-button-2" class="btn-trms-white" (click)="leaveteammodal()">Leave
                  Team</button>
              </span>
            </div>

            <div class="col d-flex justify-content-between pl-0" *ngIf="isteammember">
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20">
                  {{teamAdminDetails?.adminfirstname}} {{teamAdminDetails?.adminlastname}}
                </p>
                <p class="gray-text f-12">
                  Admin
                </p>
              </div>
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20">
                  {{teamAdminDetails?.adminemailid}}
                </p>
                <p class="gray-text f-12">
                  Admin email ID
                </p>
              </div>
              <div class="col">
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.plancost != 'free'">
                  {{subscriptiondetails?.paymentplanenddate | date:'longDate'}}
                </p>
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.plancost == 'free'">
                  NA
                </p>
                <p class="gray-text f-12">
                  Renewal Date
                </p>
              </div>

              <div class="col">
                <p class="font-weight-500 mb-1 mh-20" *ngIf="subscriptiondetails?.paymentplanstartdate">
                  {{subscriptiondetails?.paymentplanstartdate | date:'longDate'}}
                </p>
                <p class="font-weight-500 mb-1 mh-20" *ngIf="!subscriptiondetails?.paymentplanstartdate">
                  NA
                </p>
                <p class="gray-text f-12">
                  Start Date
                </p>
              </div>
              <div class="col">

              </div>
              <div class="col">

              </div>
            </div>

          </div>

          <div class="wccard">
            <div class="col font-weight-500 pt-3 pb-6">
              Account usage
            </div>

            <div class="row px-3 mr-6 mb-6">
              <div class="col-md-5 mb-4">
                <p class="font-weight-500 mb-1">
                  Jd Parsing
                </p>
                <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcreditjd" placement="top">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.jdpercentage}}"></mat-progress-bar>
                </p>

                <ng-template #remainingcreditjd>
                  <span class="f-10">
                    Remaining credits : {{subscriptiondetails?.balancejdparsingcredits}}
                  </span>
                </ng-template>
                <div class="justify-content-between d-flex f-12 font-weight-500">
                  <span class="font-weight-500">
                    0
                  </span>
                  <span class="font-weight-500">
                    {{subscriptiondetails?.jdparsingcredits}}<span
                      *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                      *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                  </span>
                </div>
              </div>

              <div class="col-md-5 mb-4  ml-auto mr-6">
                <p class="font-weight-500 mb-1" *ngIf="userisadmin">
                  Individual contact coins
                </p>
                <p class="font-weight-500 mb-1" *ngIf="!userisadmin">
                  Contact coins
                </p>
                <section *ngIf="!userisadmin">
                  <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcredit_basic_ind" placement="top"
                    *ngIf="!unlimitedbasiccontactcredits">
                    <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.bcepercentage}}">
                    </mat-progress-bar>
                  </p>

                  <p class="gray-text f-12 mb-1" *ngIf="unlimitedbasiccontactcredits">
                    <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.bcepercentage}}">
                    </mat-progress-bar>
                  </p>

                  <ng-template #remainingcredit_basic_ind>
                    <span class="f-10">
                      Remaining coins : {{subscriptiondetails?.balancebasiccontactenrichmentcredits}}
                    </span>
                  </ng-template>
                  <div class="justify-content-between d-flex f-12">
                    <span class="font-weight-500">
                      0
                    </span>
                    <span class="font-weight-500" *ngIf="!unlimitedbasiccontactcredits">
                      {{subscriptiondetails?.basiccontactenrichmentcredits}}<span
                        *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                        *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                    </span>
                    <span class="font-weight-500" *ngIf="unlimitedbasiccontactcredits">
                      Unlimited
                    </span>
                  </div>
                </section>

                <section *ngIf="userisadmin">
                  <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingbasicindividualcredits" placement="top"
                    *ngIf="!unlimitedbasiccontactcredits">
                    <mat-progress-bar mode="determinate" value="{{adminDetails?.bcepercentage}}"></mat-progress-bar>
                  </p>

                  <p class="gray-text f-12 mb-1" *ngIf="unlimitedbasiccontactcredits">
                    <mat-progress-bar mode="determinate" value="{{adminDetails?.bcepercentage}}"></mat-progress-bar>
                  </p>


                  <ng-template #remainingbasicindividualcredits *ngIf="!unlimitedbasiccontactcredits">
                    <span class="f-10">
                      Remaining credits : {{adminDetails?.usedbasiccontactcreditscount}}
                    </span>
                  </ng-template>
                  <div class="justify-content-between d-flex f-12">
                    <span class="font-weight-500">
                      0
                    </span>
                    <span class="font-weight-500" *ngIf="!unlimitedbasiccontactcredits">
                      {{adminDetails?.reservedbasiccontactcreditscount}}<span
                        *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                        *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                    </span>
                    <span class="font-weight-500" *ngIf="unlimitedbasiccontactcredits">
                      Unlimited
                    </span>
                  </div>
                </section>
              </div>

              <!-- <div class="col-md-5 mb-4">
                <p class="font-weight-500 mb-1">
                  Smart Emails
                </p>
                <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcreditse" placement="top">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.sepercentage}} ">
                  </mat-progress-bar>
                </p>

                <ng-template #remainingcreditse>
                  <span class="f-10">
                    Remaining credits : {{subscriptiondetails?.balancesmartemailcredits}}
                  </span>
                </ng-template>
                <div class="justify-content-between d-flex f-12">
                  <span class="font-weight-500">
                    0
                  </span>
                  <span class="font-weight-500">
                    {{subscriptiondetails?.smartemailcredits}}<span
                      *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                      *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                  </span>
                </div>
              </div> -->

              <!-- <div class="col-md-5 mb-4  ml-auto mr-6">
                <p class="font-weight-500 mb-1" *ngIf="userisadmin">
                  Individual premium partner coins
                </p>
                <p class="font-weight-500 mb-1" *ngIf="!userisadmin">
                  Premium partner coins
                </p>
                <section *ngIf="!userisadmin">
                  <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcredit_ind" placement="top">
                    <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.cepercentage}}">
                    </mat-progress-bar>
                  </p>

                  <ng-template #remainingcredit_ind>
                    <span class="f-10">
                      Remaining credits : {{subscriptiondetails?.balancecontactenrichmentcredits}}
                    </span>
                  </ng-template>
                  <div class="justify-content-between d-flex f-12">
                    <span class="font-weight-500">
                      0
                    </span>
                    <span class="font-weight-500">
                      {{subscriptiondetails?.contactenrichmentcredits}}<span
                        *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                        *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                    </span>
                  </div>
                </section>

                <section *ngIf="userisadmin">
                  <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingindividualcredits" placement="top">
                    <mat-progress-bar mode="determinate" value="{{adminDetails?.cepercentage}}"></mat-progress-bar>
                  </p>

                  <ng-template #remainingindividualcredits>
                    <span class="f-10">
                      Remaining credits : {{adminDetails?.usedcontactcreditscount}}
                    </span>
                  </ng-template>
                  <div class="justify-content-between d-flex f-12">
                    <span class="font-weight-500">
                      0
                    </span>
                    <span class="font-weight-500">
                      {{adminDetails?.reservedcontactcreditscount}}<span
                        *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                        *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                    </span>
                  </div>
                </section>
              </div> -->

              <div class="col-md-5 mb-4">
                <p class="font-weight-500 mb-1">
                  Talent pipelines
                </p>
                <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcredittp" placement="top">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.tppercentage}}"></mat-progress-bar>
                </p>

                <ng-template #remainingcredittp>
                  <span class="f-10">
                    Remaining credits : {{subscriptiondetails?.balancetalentpipelinecredits}}
                  </span>
                </ng-template>
                <div class="justify-content-between d-flex f-12">
                  <span class="font-weight-500">
                    0
                  </span>
                  <span class="font-weight-500">
                    {{subscriptiondetails?.talentpipelinecredits}}<span
                      *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                      *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                  </span>
                </div>
              </div>

              <!-- <div class="col-md-5 mb-4 ml-auto mr-6">
                <p class="font-weight-500 mb-1">
                  Bulk Grabbing
                </p>
                <p class="gray-text f-12 mb-1" [ngbTooltip]="remainingcreditgrab" placement="top">
                  <mat-progress-bar mode="determinate" value="{{subscriptiondetails?.grabpercentage}}">
                  </mat-progress-bar>
                </p>

                <ng-template #remainingcreditgrab>
                  <span class="f-10">
                    Remaining credits : {{subscriptiondetails?.balancebulkgrabbingcredits}}
                  </span>
                </ng-template>
                <div class="justify-content-between d-flex f-12">
                  <span class="font-weight-500">
                    0
                  </span>
                  <span class="font-weight-500">
                    {{subscriptiondetails?.bulkgrabbingcredits}}<span
                      *ngIf="subscriptiondetails?.plantype == 'monthly' || subscriptiondetails?.plantype =='custom'">/month</span><span
                      *ngIf="subscriptiondetails?.plantype == 'yearly'">/year</span>
                  </span>
                </div>
              </div> -->
            </div>

            <div class="col d-flex">

              <div class="mb-6">
                <!-- commented for beta users -->
                <!-- <button data-testid="auto-app-subscription-usage-button-3" class="wc-btn bg-blue m-auto py-2 f-12" (click)="route2page('plan')">Upgrade plan</button> -->
                &nbsp; &nbsp;
                <button data-testid="auto-app-subscription-usage-button-4" class="btn-trms-white" (click)="route2page('history')">Transaction
                  History</button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="pills-team" role="tabpanel" aria-labelledby="pills-team-tab">
        <div class="wccard" *ngIf="teamlist && teamlist.length == 0">
          <div class="col wccard text-center pt-1 pb-4">
            <div class="row mt-3">
              <div class="col py-6">
                <img src="../assets/images/search-engine-1.png" class="img-fluid" alt="" srcset="">
              </div>
            </div>
            <div class="pb-4">
              <p class="font-weight-500 f-14 py-3 gray-text">Nothing to see here</p>
            </div>
            <div class="mb-6">
              <button data-testid="auto-app-subscription-usage-button-5" class="btn-trms-medium mr-4"
                (click)="invitemembermodal()">Invite Members</button>
              <button data-testid="auto-app-subscription-usage-button-6" class="btn-trms-white" (click)="copyinvitelink()">Invite using
                link</button>
            </div>
          </div>
        </div>

        <section *ngIf="teamlist && teamlist.length > 0">
          <div class="col wccard d-flex py-2 mb-3px" *ngIf="!isBulkSelect &&  selectedteams.length == 0">
            <div class="col">
              <div class="d-flex">
                <div class="d-flex align-items-center">
                  <label class="wc-checkbox mr-3 mb-0">
                    <input data-testid="auto-app-subscription-usage-input-1" [(ngModel)]="selected" (change)="selectAll(selected)" [ngModelOptions]="{standalone: true}"
                      type="checkbox" id="mycheck" name="mycheck">
                    <i class="fas fa-check"></i>
                  </label>

                  <span class="font-weight-500 f-14">Name</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class=" font-weight-500 d-flex f-14">
                Email
              </div>
            </div>

            <div class="col">
              <div class="font-weight-500 d-flex f-14">
                Contact coins
              </div>
            </div>
            <div class="col">
              <div class="font-weight-500 d-flex f-14">
                Premium partner coins
              </div>
            </div>
            <div class="col d-flex" style="white-space: nowrap;">
              <div class="d-flex">
                <span class="px-2 mr-2">
                  <div class="mt-3px">
                    <span class="font-weight-600">{{tstart+1}}-{{end}}</span> of {{total}} results
                  </div>
                </span>
                <span class="px-2 f-20">
                  <a data-testid="auto-app-subscription-usage-a-3" (click)="tstart > 0 && pagination('prev')" class="mr-1 text-black"><i
                      class="fas fa-caret-left"></i></a>
                  &nbsp;
                  <a data-testid="auto-app-subscription-usage-a-4" (click)="end < total && pagination('next')" class="ml-1 text-black"><i
                      class="fas fa-caret-right"></i></a>
                </span>
              </div>
              <span class="ml-3 ats-cta-btn f-12 pointer" (click)="invitemembermodal()">
                <i class="fas fa-user-plus"></i>
              </span>

              <span class="ml-3 ats-cta-btn f-12 pointer" (click)="copyinvitelink()">
                <i class="fas fa-link"></i>
              </span>
            </div>
          </div>

          <div class="col wccard d-flex py-2 mb-3px" *ngIf="isBulkSelect || selectedteams.length > 0">
            <div class="col px-0">
              <div class="col">
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center">
                    <label class="wc-checkbox mr-3 mb-0">
                      <input data-testid="auto-app-subscription-usage-input-2" [(ngModel)]="selected" (change)="selectAll(selected)" [ngModelOptions]="{standalone: true}"
                        type="checkbox" id="mycheck" name="mycheck">
                      <i class="fas fa-check"></i>
                    </label>

                    <span class="font-weight-500 f-14">{{selectedteams.length}} selected</span>
                  </div>
                  <div>
                    <span class="ats-cta-btn f-12 pointer" (click)="changebulkcreditsforteam()">
                      <i class="fas fa-coin pointer"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col px-0">
            <div class="col wccard py-4 oncardlistHover pointer" style="word-break: break-all;">
              <div class="col d-flex px-0">
                <div class="col">
                  <div class="d-flex">
                    <label class="wc-checkbox mr-3 mb-0">
                      <input data-testid="auto-app-subscription-usage-input-3" disabled type="checkbox" id="mycheck" name="mycheck">
                      <i class="fas fa-check"></i>
                    </label>
                    <div>
                      <p class="mb-1 pointer no-outline">
                        <span class="font-weight-600 text-capitalize mr-1" style="white-space: pre-wrap;">
                          <span>
                            {{adminDetails?.firstname}} {{adminDetails?.lastname}}
                          </span>
                          <span class="ml-3 f-14 pointer text-webbtree-green" title="Admin">
                            <i class="fas fa-user-shield"></i>
                          </span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <p class="mb-1">{{adminDetails?.loginemail}}</p>
                </div>



                <div class="col" *ngIf="!unlimitedbasiccontactcredits">
                  <p class="mb-1">{{adminDetails?.usedbasiccontactcreditscount}} /
                    {{adminDetails?.reservedbasiccontactcreditscount}}</p>
                </div>

                <div class="col" *ngIf="unlimitedbasiccontactcredits">
                  <p class="mb-1"> Unlimited</p>
                </div>

                <div class="col">
                  <p class="mb-1">{{adminDetails?.usedcontactcreditscount}} /
                    {{adminDetails?.reservedcontactcreditscount}}</p>
                </div>

                <div class="col">
                  <div class='d-flex flex-column text-right'>
                    <div class="onhverNotesEllipsis">
                      <div class="text-right d-flex position-absolute tr0">
                        <span class="list-cta-group">
                          <span title="Edit Credits" class="mr-3 ats-cta-btn f-12 pointer" (click)="editAdminCredits()">
                            <i class="far fa-edit"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col px-0" *ngFor="let x of teamlist">
            <div class="col wccard py-4 oncardlistHover pointer" style="word-break: break-all;">
              <div class="col d-flex px-0">
                <div class="col">
                  <div class="d-flex">
                    <label class="wc-checkbox mr-3 mb-0">
                      <input data-testid="auto-app-subscription-usage-input-4" [checked]="x.selected" [(ngModel)]="x.selected" (change)="checkIfAllSelected(x,x.selected)"
                        type="checkbox" id="mycheck" name="mycheck">
                      <i class="fas fa-check"></i>
                    </label>
                    <div>
                      <p class="mb-1 pointer no-outline">
                        <span class="font-weight-600 text-capitalize mr-1" style="white-space: pre-wrap;">
                          <span *ngIf="x.firstname">
                            {{x.firstname}} {{x.lastname}}
                          </span>
                          <span *ngIf="!x.firstname">
                            N/A
                          </span>
                          <span class="pending-text" *ngIf="x.invitestatus == 'sent'">
                            Pending
                          </span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <p class="mb-1">{{x.inviteeemailid}}</p>
                </div>



                <div class="col" *ngIf="!unlimitedbasiccontactcredits">
                  <p class="mb-1">{{x.balancebasiccontactenrichmentcredits}} / {{x.basiccontactenrichmentusagelimit}}
                  </p>
                </div>

                <div class="col" *ngIf="unlimitedbasiccontactcredits">
                  <p class="mb-1"> Unlimited</p>
                </div>

                <div class="col">
                  <p class="mb-1">{{x.balancecontactenrichmentcredits}} / {{x.contactenrichmentusagelimit}}</p>
                </div>

                <div class="col">
                  <div class='d-flex flex-column text-right'>
                    <div class="onhverNotesEllipsis">
                      <div class="text-right d-flex position-absolute tr0">
                        <span class="list-cta-group">
                          <span title="Invite member" class="mr-3 ats-cta-btn f-12 pointer"
                            (click)="invitemembermodal(x)">
                            <i class="far fa-edit"></i>
                          </span>

                          <span title="Resend link" class="mr-3 ats-cta-btn f-12 pointer" (click)="resendlinkmodal(x)"
                            *ngIf="x.invitestatus == 'sent'">
                            <i class="fas fa-share-square"></i>
                          </span>

                          <span title="Remove member" class="mr-3 ats-cta-btn f-12 pointer"
                            (click)="removemembermodal(x)">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  </div>
</div>



<section *ngIf="history">

  <div class="col wccard py-2">
    <div class="d-flex">
      <i class="fas fa-arrow-left mr-3 mt-1 pointer" (click)="route2page('usage')"></i>
      <span class="f-14 mt-3px font-weight-500 d-flex justify-content-between pointer"> Transaction history
      </span>
    </div>
  </div>

  <div class="col wccard text-center pt-1" *ngIf="transactionhistory && transactionhistory.length == 0">
    <div class="row mt-3">
      <div class="col py-6">
        <img src="../assets/images/candidate-list-empty.png" class="img-fluid" alt="" srcset="">
      </div>
    </div>
    <div class="pb-4">
      <p class="font-weight-500 f-14 py-3 gray-text">No transaction history</p>
    </div>
  </div>

  <div class="wccard" *ngIf="transactionhistory && transactionhistory.length > 0">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col" class="font-weight-500">Plan name</th>
          <th scope="col" class="font-weight-500">Price</th>
          <th scope="col" class="font-weight-500">Transation date</th>
          <th scope="col" class="font-weight-500">Valid upto</th>
          <th scope="col" class="font-weight-500">Transaction ID</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let history of transactionhistory">
          <td> {{history.paymentplanname}} </td>
          <td> <span class="font-weight-500">
              $
            </span>{{history.plancost}}/<span
              *ngIf="history?.plantype =='custom' || history?.plantype =='monthly'">Month</span>
            <span *ngIf="history?.plantype == 'yearly'">Year</span>
          </td>
          <td>{{history.paymentplanstartdate | date:'longDate'}}</td>
          <td> {{history.paymentplanenddate | date:'longDate'}}</td>
          <td>{{history.transactionid}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>


<ng-template #invitemember class="modal">

  <div class="modal-content">
    <div class="modal-header b pb-0 px-5 pt-4">
      <h5 class="modal-title f-16 font-weight-600" id="team" *ngIf="selectedteams && selectedteams.length == 0">Invite
        team members</h5>
      <h5 class="modal-title f-16 font-weight-600" id="team" *ngIf="selectedteams && selectedteams.length > 0">Change
        coins limit</h5>
      <button data-testid="auto-app-subscription-usage-button-7" type="button" class="close py-3 font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="col">
        <section *ngIf="selectedteams && selectedteams.length == 0">
          <div class="f-12 font-weight-500 mb-4">
            Invite using a link <i class="fas fa-info-circle text-dis ml-2" [ngbTooltip]="xD" placement="right"
              tooltipClass="my-custom-class"></i>
            <ng-template #xD>
              <span class="f-10"> Any user joining using this link will have “0” credits assign </span>
            </ng-template>
            <div class="d-flex justify-content-between mt-1">
              <span class="copy-div">
                <input data-testid="auto-app-subscription-usage-input-5" type="text" class="wc-form-control nobg mt-3px" id="invite_link" [(ngModel)]="invitelink">
              </span>
              <span style="width: 100px;" (click)="copyinvitelink()">
                <button data-testid="auto-app-subscription-usage-button-8" class="btn-trms-small">Copy</button>
              </span>
            </div>
          </div>
          <hr class="hr-text" data-content="or">
        </section>
        <div class="mb-4">
          <div class="f-12 font-weight-500 mb-2"> Enter email ID
            <input data-testid="auto-app-subscription-usage-input-6" type="text" placeholder="Enter email ID" class="wc-form-control nobg mt-1" [(ngModel)]="inputemails"
              [ngClass]="{'disabled-input':selectedteams && selectedteams.length > 0}" (keyup.enter)="addemails()">
          </div>
          <p *ngIf="emailError" class="f-12 text-danger mb-2">
            Please Enter Valid Email id
          </p>
          <p *ngIf="duplicateEmail" class="f-12 text-danger mb-2">
            User with entered email id already exists
          </p>
          <p *ngIf="adminEmailidUsed" class="f-12 text-danger mb-2">
            Cannot enter your own email id
          </p>
          <p *ngIf="emailLengthError" class="f-12 text-danger mb-2">
            Please Enter atleast one email id
          </p>
          <span class="newchip mr-2 d-inline-blocktext-capitalize" *ngFor="let email of inviteemails">{{email}}
            <span class="ml-2"><i class="fal fa-times f-14 text-blue" aria-hidden="true"
                (click)="removeemails(email)"></i></span>
          </span>
        </div>

        <div class="f-12 font-weight-500 mb-4"> Usage premium partner coins per user (Available Coins :
          {{subscriptiondetails?.pooledbalancecontactenrichmentcredits ?
          subscriptiondetails?.pooledbalancecontactenrichmentcredits : 0}})
          <i class="fas fa-info-circle text-dis ml-2" [ngbTooltip]="nextplan" placement="right"
            tooltipClass="my-custom-class"></i>
          <ng-template #nextplan>
            <span class="f-10"> Next credit cycle : {{subscriptiondetails?.paymentplanenddate | date:'longDate'}}</span>
          </ng-template>
          <input data-testid="auto-app-subscription-usage-input-7" type="number" placeholder="Enter premium contacts credits" class="wc-form-control nobg mt-1"
            [(ngModel)]="credits" (keypress)="noDecimals($event)">
        </div>

        <div class="f-12 font-weight-500 mb-4"> Usage contacts coins per user
          <span *ngIf="!unlimitedbasiccontactcredits">
            (Available Coins : {{subscriptiondetails?.pooledbalancebasiccontactenrichmentcredits ?
            subscriptiondetails?.pooledbalancebasiccontactenrichmentcredits : 0}})
          </span>
          <!-- <i class="fas fa-info-circle text-dis ml-2"
          [ngbTooltip]="nextcdplan" placement="right" tooltipClass="my-custom-class"></i> -->
          <!-- <ng-template #nextcdplan>
          <span class="f-10"> Next credit cycle : {{subscriptiondetails?.paymentplanenddate | date:'longDate'}}</span>
        </ng-template> -->
          <input data-testid="auto-app-subscription-usage-input-8" type="number" placeholder="Enter basic contacts credits" class="wc-form-control nobg mt-1"
            (keypress)="noDecimals($event)" *ngIf=!unlimitedbasiccontactcredits [(ngModel)]="basiccredits">
          <input data-testid="auto-app-subscription-usage-input-9" type="text" placeholder="Unlimited" disabled class="wc-form-control nobg mt-1"
            *ngIf=unlimitedbasiccontactcredits>
        </div>

        <p class="f-14 text-danger" *ngIf="noAdminCredits">
          <i class="fas fa-info-circle mr-2 "></i> Usage limit exceeds amount of credits available
        </p>
        <div class="text-center" *ngIf="selectedteams && selectedteams.length == 0">
          <button data-testid="auto-app-subscription-usage-button-9" class="btn-trms-small" (click)="invitemembers()">Invite</button>
        </div>

        <div class="text-center" *ngIf="selectedteams && selectedteams.length > 0">
          <button data-testid="auto-app-subscription-usage-button-10" class="btn-trms-small" (click)="savebulkcredits()">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ng-template #removeteam>
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="experience"></h5>
    <button data-testid="auto-app-subscription-usage-button-11" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-0">
    <div class="row mb-4">
      <div class="col">
        <p>Are you sure you want to remove {{removedmemberArray[0].inviteeemailid}} from this group?</p>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-subscription-usage-button-12" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-subscription-usage-button-13" class="btn-trms-small" (click)="RemoveTeam()">YES</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #resendlink>
  <div class="modal-header b pb-0">
    <h5 class="modal-title" id="experience"></h5>
    <button data-testid="auto-app-subscription-usage-button-14" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-0">
    <div class="row mb-4">
      <div class="col">
        <p>Are you sure you want to resend invitation link to {{resendteamArray[0].inviteeemailid}}?</p>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-subscription-usage-button-15" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-subscription-usage-button-16" class="btn-trms-small" (click)="resendLink()">YES</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #requestCredit class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-subscription-usage-button-17" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Request more credits</p>
          <p class="">You have exhausted your limit to send emails, Request more credits from your team admin to keep
            going</p>
        </div>
      </div>
      <!-- <div class="row">
              <div class="col-md-10 mx-auto d-flex">
                  <button data-testid="auto-app-subscription-usage-button-18" class="wc-btn bg-blue m-auto py-3" (click)="route2pricing()">Upgrade plan</button>
              </div>
          </div> -->
    </div>
  </div>
</ng-template>


<ng-template #reservecredits class="modal">

  <div class="modal-content">
    <div class="modal-header b pb-0 px-5 pt-4">
      <h5 class="modal-title f-16 font-weight-600" id="team">Reserve coins for yourself</h5>
      <button data-testid="auto-app-subscription-usage-button-19" type="button" class="close py-3 font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body px-3 pb-6 pt-3">
      <div class="col">
        <div class="f-12 font-weight-500 mb-4"> Reserve premium partner coins for yourself <i
            class="fas fa-info-circle text-dis ml-1" [ngbTooltip]="reserveCred" placement="right"
            tooltipClass="my-custom-class"></i>
            (Available Coins : {{teamlist?.length > 0 || userisadmin ? subscriptiondetails?.pooledbalancecontactenrichmentcredits : subscriptiondetails?.balancecontactenrichmentcredits}})
          <ng-template #reserveCred>
            <span class="f-10"> Reserve premium enrichment coins for yourself from the total available credits. You
              can then assign the remaining coins to
              other users that you add to the team</span>
          </ng-template>
          <input data-testid="auto-app-subscription-usage-input-10" type="number" placeholder="Enter credits" class="wc-form-control nobg mt-1" [(ngModel)]="admincredits"
            (keypress)="noDecimals($event)">
        </div>

        <div class="f-12 font-weight-500 mb-4"> Reserve contacts coins for yourself
          <span *ngIf="!unlimitedbasiccontactcredits">
            (Available Coins : {{teamlist?.length > 0 || userisadmin ?
            subscriptiondetails?.pooledbalancebasiccontactenrichmentcredits :
            subscriptiondetails?.balancebasiccontactenrichmentcredits}})
          </span>
          <input data-testid="auto-app-subscription-usage-input-11" type="number" placeholder="Enter basic credits" class="wc-form-control nobg mt-1"
            (keypress)="noDecimals($event)" *ngIf=!unlimitedbasiccontactcredits [(ngModel)]="adminbasiccredits">
          <input data-testid="auto-app-subscription-usage-input-12" type="text" placeholder="Unlimited" disabled class="wc-form-control nobg mt-1"
            *ngIf=unlimitedbasiccontactcredits>
        </div>

        <p class="f-14 text-danger" *ngIf="noAdminCredits">
          <i class="fas fa-info-circle mr-2"></i> Usage limit exceeds amount of coins available
        </p>

        <p class="f-14 text-danger">
          {{admincreditsError}}
        </p>
        <div class="text-center">
          <button data-testid="auto-app-subscription-usage-button-20" class="btn-trms-small" (click)="reservecreditsAdmin()">Reserve</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #leaveteam>
  <div class="modal-body">
    <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-subscription-usage-button-21" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
        <button data-testid="auto-app-subscription-usage-button-22" class="btn-trms-small" (click)="submitleaveteam()">YES</button>
      </div>
    </div>
  </div>
</ng-template>



<ng-template #cancelSubscription>
  <div class="modal-header b pb-0 mb-5">
    <h6 class="modal-title f-14" id="experience">Cancel current Subscription?</h6>
    <button data-testid="auto-app-subscription-usage-button-23" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row mb-4">
      <div class="col">
        <p>Your current plan will be canceled and the account will be moved to a Free Plan immediately</p>
      </div>
    </div>
    <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-subscription-usage-button-24" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">Dismiss</button>
        <button data-testid="auto-app-subscription-usage-button-25" class="btn-trms-medium" (click)="cancelsubs()">Cancel Plan</button>
      </div>
    </div>
  </div>
</ng-template>
